import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';

@Component({
  selector: 'app-error-snack-bar',
  template: `
    <mat-list dense>
      <mat-list-item>
        <p mat-line>{{ data.op }} {{ data.message || data.err }}</p>
        <mat-icon class="material-icons">info</mat-icon>
      </mat-list-item>
    </mat-list>
  `,
  styles: [
    `
      * {
        color: gray;
      }

      .error-msg {
        background: #d35400 !important;
      }
    `
  ]
})
export class ErrorMessageComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    console.log(data);
  }
}

@Component({
  selector: 'app-event-snack-bar',
  template: `
    <div class="event-msg">
      <mat-icon class="material-icons">info</mat-icon>
      <span>{{ data.message | translate }}</span>
    </div>
  `,
  styles: [
    `
      * {
        color: silver;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      span {
        padding-left: 15px;
        /*flex: 2;*/
      }
    `
  ]
})
export class EventMessageComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/handler-server-respond/handler-server-respond.component.ts